const ACTIVITY_STORAGE_KEY = 'lastActivitySent';
const CHECK_INTERVAL_MS = 60 * 60 * 1000; // 1 hour

let activityCheckInterval = null;

export const getLastActivityTimestamp = () => {
  try {
    const timestamp = localStorage.getItem(ACTIVITY_STORAGE_KEY);
    return timestamp ? parseInt(timestamp, 10) : null;
  } catch (error) {
    console.error('Error reading activity timestamp:', error);
    return null;
  }
};

export const setLastActivityTimestamp = (timestamp) => {
  try {
    localStorage.setItem(ACTIVITY_STORAGE_KEY, timestamp.toString());
  } catch (error) {
    console.error('Error saving activity timestamp:', error);
  }
};

export const shouldSendActivity = () => {
  const lastActivityTimestamp = getLastActivityTimestamp();
  const currentTimestamp = Date.now();
  const oneHourAgo = currentTimestamp - CHECK_INTERVAL_MS;

  return !lastActivityTimestamp || lastActivityTimestamp < oneHourAgo;
};

export const markActivityAsSent = () => {
  setLastActivityTimestamp(Date.now());
};

export const getActivityData = (userInfo) => {
  return {
    username: userInfo?.["cognito:username"],
    timestamptz: new Date().toISOString(),
  };
};

export const startActivityTracking = (sendActivityCallback) => {
  stopActivityTracking();

  activityCheckInterval = setInterval(async () => {
    if (shouldSendActivity()) {
      await sendActivityCallback();
    }
  }, CHECK_INTERVAL_MS);
};

export const stopActivityTracking = () => {
  if (activityCheckInterval) {
    clearInterval(activityCheckInterval);
    activityCheckInterval = null;
  }
};
